import styled from 'styled-components';
import { navy, grey75, coral, pink25 } from '@zocdoc/branding/colors';
import { FontFamily } from '../../../../typography';
import { breakpoint } from '../../../../grid';
import { CSSTransitionGroup } from 'react-transition-group';

const delay = '300ms';

export const InsuranceTransitionGroup = styled(CSSTransitionGroup)`
    .left-enter {
        transform: translate(-100%);
        position: absolute;
        top: 0;
    }
    .left-enter.left-enter-active {
        transform: translate(0%);
        transition: transform ${delay} ease-in-out;
    }
    .left-leave {
        transform: translate(0%);
        position: absolute;
        top: 0;
    }
    .left-leave.left-leave-active {
        transform: translate(-100%);
        transition: transform ${delay} ease-in-out;
    }
    .right-enter {
        transform: translate(100%);
        position: absolute;
        top: 0;
    }
    .right-enter.right-enter-active {
        transform: translate(0%);
        transition: transform ${delay} ease-in-out;
    }
    .right-leave {
        transform: translate(0%);
        position: absolute;
        top: 0;
    }
    .right-leave.right-leave-active {
        transform: translate(100%);
        transition: transform ${delay} ease-in-out;
    }
`;

export const SectionHeader = styled.div`
    font: 15px/24px ${FontFamily.SharpSansSemibold};
    text-size-adjust: none;
    color: ${grey75};
    width: 100%;
    padding: 24px 20px 4px;
`;

export const SectionItem = styled.div`
    font: 15px/35px ${FontFamily.SharpSansMedium};
    box-sizing: inherit;
    padding: 4px 20px;
    position: relative;
    list-style: none;
    text-size-adjust: none;

    color: ${navy};

    em {
        color: ${coral};
    }

    &:active {
        cursor: pointer;
        background-color: ${pink25};
        -webkit-tap-highlight-color: ${pink25};
    }

    ${breakpoint.small} {
        &:hover {
            cursor: pointer;
            background-color: ${pink25};
        }
    }
`;
